var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74527 0.408412C5.26107 -0.136138 6.09735 -0.136137 6.61315 0.408413C7.12895 0.952963 7.12895 1.83585 6.61315 2.3804L2.25477 6.98171C1.73897 7.52626 0.902689 7.52626 0.386889 6.98171C-0.128911 6.43716 -0.128911 5.55427 0.386889 5.00972L4.74527 0.408412Z",
    fill: "#9E9288"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61311 9.6196C7.12891 10.1641 7.12891 11.047 6.61311 11.5916C6.09731 12.1361 5.26103 12.1361 4.74523 11.5916L0.38685 6.99028C-0.12895 6.44573 -0.12895 5.56284 0.38685 5.01829C0.902651 4.47374 1.73893 4.47374 2.25473 5.01829L6.61311 9.6196Z",
    fill: "#9E9288"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftSm);
export default __webpack_public_path__ + "static/media/chevron-left-sm.d958d60c1f3f64d9377bac00348f46c1.svg";
export { ForwardRef as ReactComponent };